// extracted by mini-css-extract-plugin
module.exports = {"tabButtons":"TabButtons_tabButtons__Eq19J","tabButton":"TabButtons_tabButton__gpuWE","active":"TabButtons_active__GLYmp"};